"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCreateNewAdminAccountMethodRequest = exports.CreateNewAdminAccountSchema = void 0;
const yup = __importStar(require("yup"));
const User_1 = require("./User");
const ValidationError_1 = require("../errors/ValidationError");
/**
 * Schema for create new admin account method validation
 * {@link ICreateNewAdminAccountRequestBody}
 */
const CreateNewAdminAccountSchema = yup.object().shape({
    salutation: User_1.UserSchema.salutation,
    firstName: User_1.UserSchema.firstName,
    secondName: User_1.UserSchema.secondName,
    thirdName: User_1.UserSchema.thirdName,
    familyName: User_1.UserSchema.familyName,
    email: yup.string().email().required("Please enter email").max(255),
    password: User_1.UserSchema.password,
    confirmPassword: User_1.UserSchema.confirmPassword,
    tncAccepted: yup.boolean().oneOf([true], "Must accept terms & conditions").required("Must accept terms & conditions"),
});
exports.CreateNewAdminAccountSchema = CreateNewAdminAccountSchema;
/**
 * Validates create new admin account method request schema
 * @param data: create new admin account method request {@link ICreateNewAdminAccountRequestBody} to validate
 */
const validateCreateNewAdminAccountMethodRequest = (data) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield CreateNewAdminAccountSchema.validate(data, {
            abortEarly: false,
        });
        return;
    }
    catch (err) {
        if (err instanceof yup.ValidationError) {
            const errorMessage = err.errors.toString();
            throw new ValidationError_1.ValidationError(errorMessage);
        }
        else {
            throw err;
        }
    }
});
exports.validateCreateNewAdminAccountMethodRequest = validateCreateNewAdminAccountMethodRequest;
//# sourceMappingURL=CreateNewAdminAccount.js.map